import { homeContent } from "@/content/home";
import { ArrowRight } from "@/components/ui/Icons";

const CURRENT_YEAR = new Date().getFullYear();

// Legal placeholder links — disabled until /privacy, /terms, and /security
// routes ship. aria-disabled + non-navigable href avoids 404s.
const DISABLED_LEGAL_LINKS = new Set(["Privacy", "Terms", "Security"]);

export function Footer() {
  const content = homeContent.footer;
  return (
    <footer className="border-t border-rule bg-canvas px-6 pb-8 pt-20 md:px-[72px]">
      <div className="mx-auto flex max-w-[1296px] flex-col gap-16">
        <div className="flex flex-col gap-12 lg:flex-row lg:justify-between">
          <FooterBrand tagline={content.tagline} />
          <div className="grid grid-cols-2 gap-12 sm:grid-cols-3 lg:gap-12">
            {content.columns.map((col) => (
              <div key={col.heading} className="flex flex-col gap-4">
                <p className="text-[11px] font-semibold uppercase tracking-[0.08em] text-pencil">
                  {col.heading}
                </p>
                <ul className="flex flex-col gap-4">
                  {col.links.map((link) => {
                    const disabled = DISABLED_LEGAL_LINKS.has(link.label);
                    return (
                      <li key={link.label}>
                        <a
                          href={link.href}
                          aria-disabled={disabled || undefined}
                          title={disabled ? "Coming soon" : undefined}
                          className={
                            disabled
                              ? "cursor-not-allowed text-[14px] font-medium text-ink/50 no-underline"
                              : "text-[14px] font-medium text-ink no-underline hover:text-cloak-accent"
                          }
                        >
                          {link.label}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <hr className="border-t border-rule" />

        <div className="flex flex-wrap items-center gap-6 text-[12px] font-medium text-pencil">
          <span>© {CURRENT_YEAR} Cloakling</span>
          <span
            aria-hidden="true"
            className="h-1.5 w-1.5 rounded-full bg-cloak-accent"
          />
          <span>{content.status}</span>
        </div>
      </div>
    </footer>
  );
}

function FooterBrand({ tagline }: { tagline: string }) {
  return (
    <div className="flex w-full max-w-[380px] flex-col gap-5">
      <div className="flex items-center gap-2">
        <img src="/logo.png" alt="" aria-hidden="true" className="h-10 w-10 object-contain" />
        <span className="text-[18px] font-bold tracking-[-0.2px] text-ink">
          Cloakling
        </span>
      </div>
      <p className="text-[14px] leading-[1.55] text-graphite">{tagline}</p>
      <a
        href="https://cloakling.dev"
        className="inline-flex items-center gap-2 self-start rounded-md bg-cloak-accent px-[18px] py-2.5 text-[14px] font-semibold text-page no-underline hover:bg-cloak-accent/90"
      >
        Get access
        <ArrowRight size={14} />
      </a>
    </div>
  );
}
